<template>
  <v-footer app color="blue">
    <div v-html="$vuetify.lang.translator('copyright')"></div>
    <v-spacer></v-spacer>
    <span>{{ $vuetify.lang.translator("version") }} 2.7.0</span>
  </v-footer>
</template>

<script>
export default {
  name: "MyFooter"
};
</script>
